<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Môn học"
          :link="[
            { text: 'Nâng cao', href: '../divisions' },
            { text: 'Môn học', href: '../subjects' },
          ]"
        />
      </div>
      <div class="d-flex align-end" :class="{ 'flex-column align-center ': $vuetify.breakpoint.smAndDown }">
        <v-btn outlined color="success" @click="exportExcel" v-if="windowWidth > 1000">
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn>
        <v-btn
          v-if="$auth.policies['add-new-subject']"
          class="ml-6"
          depressed
          color="primary"
          @click="createCoreSubject = !createCoreSubject"
          :block="$vuetify.breakpoint.smAndDown"
          :class="{ 'my-2 mr-6': $vuetify.breakpoint.smAndDown }"
        >
          Thêm môn chính khóa
        </v-btn>
        <v-btn
          v-if="$auth.policies['add-new-subject']"
          class="ml-6"
          outlined
          color="primary"
          @click="createExtraSubject = !createExtraSubject"
          :block="$vuetify.breakpoint.smAndDown"
          :class="{ 'mr-6': $vuetify.breakpoint.smAndDown }"
        >
          Thêm môn bổ trợ
        </v-btn>
      </div>
    </div>
    <SubjectNewDialog :state="createCoreSubject" />
    <ExtraSubjectNewDialog :state="createExtraSubject" />

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <SubjectFilter @onFilterChanged="refresh" :windowWidth="windowWidth" />
    </v-card>

    <v-card class="mx-4 elevation-0" outlined>
      <v-data-table
        :headers="headers"
        :options.sync="subjectTableOptions"
        :items="subjects"
        :loading="loading"
        @click:row="onSelected"
        ref="subjectDataTable"
        :footer-props="{ 'items-per-page-text': 'Số môn một trang', 'items-per-page-all-text': 'Tất cả' }"
        disable-sort
      >
        <template v-slot:[`footer.page-text`]="items">
          {{ items.pageStart }} - {{ items.pageStop }} trên tổng
          {{ items.itemsLength }}
        </template>
        <template v-slot:[`item.title`]="{ item }">
          <router-link style="text-decoration: none; white-space: nowrap" :to="'/subject/' + item.id">{{
            item.title
          }}</router-link>
        </template>
        <template v-slot:[`item.grade`]="{ item }">
          {{ item.grade | getGrade }}
        </template>
        <template v-slot:[`item.markType`]="{ item }">
          {{ item.markType | getMarkType }}
        </template>
        <template v-slot:[`item.type`]="{ item }">
          {{ item.type | getSubjectType }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import SubjectNewDialog from '@/modules/subject/SubjectNewDialog'
import SubjectFilter from '@/modules/subject/SubjectFilter.vue'
import utils from '@/plugins/utils'
import ExtraSubjectNewDialog from '@/modules/subject/ExtraSubjectNewDialog.vue'

export default {
  components: {
    SubjectNewDialog,
    Breadcrumbs,
    SubjectFilter,
    ExtraSubjectNewDialog,
  },
  props: {
    role: String,
  },
  data() {
    return {
      isLoading: false,
      headers: [
        { text: 'Tên môn học', value: 'title' },
        { text: 'Bộ môn', value: 'subjectGroup.title' },
        { text: 'Nhóm môn học', value: 'type' },
        { text: 'Học phần', value: 'grade' },
        { text: 'Phân ban', value: 'division.title' },
        { text: 'Hệ số tổng kết', value: 'multiply', align: 'center' },
        { text: 'Đánh giá theo', value: 'markType' },
      ],
      createCoreSubject: false,
      createExtraSubject: false,
      selected: {},
      windowWidth: window.innerWidth,
      subjectTableOptions: {},
      page: 0,
      itemsPerPage: 10,
    }
  },

  computed: {
    ...mapState('subjects', ['subjects', 'loading']),
    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm môn'
      }
    },
  },
  async created() {
    await this.refresh({})
  },
  methods: {
    ...mapActions('subjects', ['fetchSubjects', 'removeSubject', 'requestPageSettings']),
    updateDraw(draw) {
      this.draw = draw
    },
    async refresh(query) {
      try {
        await this.fetchSubjects({ ...query })
        this.subjectTableOptions = {
          page: 1,
        }
      } catch (err) {
        this.$alert.error(err)
      }
    },
    onSubjectSelected(subject) {
      this.setSubject(subject)
    },
    onSelected(subject) {
      this.$router.push(`./subject/${subject.id}`)
    },
    exportExcel() {
      this.$loading.active = true
      try {
        const excelHeader = this.headers.map(({ text, value }) => ({ text, value }))
        const subjects = JSON.parse(JSON.stringify(this.subjects))
        const filters = this.$options.filters
        const data = subjects.map((item) => {
          item.markType = filters.getMarkType(item.markType)
          item.type = filters.getSubjectType(item.type)
          item.grade = filters.getGrade(item.grade)
          return item
        })
        utils.exportExcel(data, excelHeader, 'DanhSachMonHoc')
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
  },
  filters: {
    getGrade(grade) {
      if (!grade) return ''
      return grade.title
    },
    getSubjectType(item) {
      return item === 'coreCurriculum' ? 'Chính khoá' : 'Bổ trợ'
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  },
  watch: {
    subjectTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>
